
import Vue from "vue";
import { secureFileDownload } from "@/helpers/secureDownload";
export default Vue.extend({
  name: "DataView",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    async downloadFile(attachment: any) {
      await secureFileDownload(attachment._id, attachment.name);
    }
  },
  computed: {}
});
